import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';
import { getContenTypePorTipoDePadron, getTipoDePadronPorContenType } from 'api/catalogos';

export const baseURI = 'recaudacion/origen-del-credito-pae/';

/**
 * GET Origenes de Crédito
 * param {object} params
 * @returns {Promise<object>}
 */
export const getOrigenesDeCredito = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    const data = response.data.map((item) => ({
      ...item,
      tipo_de_padron: item?.content_type_padron
        ? getTipoDePadronPorContenType(item?.content_type_padron) : null,
    }));
    return data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Origen de Crédito
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getOrigenDeCredito = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    const data = {
      ...response.data,
      tipo_de_padron: response.data?.content_type_padron
        ? getTipoDePadronPorContenType(response.data?.content_type_padron) : null,
    };
    return data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Origen de Crédito
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postOrigenDeCredito = async (values) => {
  try {
    const response = await API.post(baseURI, {
      ...values,
      content_type_padron: getContenTypePorTipoDePadron(values.tipo_de_padron),
      padron: values.tipo_de_padron,
    });
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Origen de Crédito
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchOrigenDeCredito = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      ...values,
      content_type_padron: getContenTypePorTipoDePadron(values.tipo_de_padron),
      padron: values.tipo_de_padron,
    });
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Origen de Crédito
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteOrigenDeCredito = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
